export enum SettingsEnum {
	general = 'general',
	journal = 'journal'
}

export type Settings = SettingRow[];

export interface SettingRow {
	persistent?: boolean;
	key: string;
	value: unknown;
}
